import React, { Component, useState, Fragment } from "react";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import { Accordion, Card } from "react-bootstrap";
import CheckBoxComponent from '../CheckBox';
import SpanMoreTabDown from "../../images/chevron-down-small.svg";
import SpanMoreTabTop from "../../images/chevron-top.svg";
import InfoIconComponent from "../../components/InfoIcon";
const imgScale = {
    width: "24px",
    height: "24px"
  };
const Icon = props => (
    <img className={props.className} src={props.src} {...imgScale} />
);

function CustomToggle({ init, children, eventKey, text }) {
    const decoratedOnClick = useAccordionToggle(eventKey);
    const [toggle, setToggle] = useState(true);
  
    const onToggle = e => {
      e.stopPropagation();
      setToggle(!toggle);
      decoratedOnClick();
    };

    return (
        <div className="d-flex align-item-center accordion-header" onClick={e => onToggle(e)}>
            <p className="header-accordion-text position-relative">
              โปรดระบุความประสงค์ในการใช้สิทธิยกเว้นภาษีเงินได้
              <InfoIconComponent id="CheckBoxTax" text="ตามประกาศอธิบดีกรมสรรพากรเกี่ยวกับภาษีเงินได้ ฉบับที่ 315 ผู้เอาประกันภัยสามารถนำเบี้ยประกันภัยอุบัติเหตุ และสุขภาพไปขอยกเว้นภาษีเงินได้บุคคลธรรมดาได้ตามจำนวนที่จ่ายจริง แต่ไม่เกิน 15,000 บาททั้งนี้เมื่อรวมกับค่าลดหย่อนของเบี้ยประกันชีวิตต้องไม่เกิน 100,000 บาท ซึ่งการนำส่งข้อมูลเพื่อยื่นขอใช้สินทธิยกเว้นภาษีเงินได้ให้บริษัทฯ ทราบ และยินยอมให้บริษัทฯ เปิดเผนข้อมูลการชำระเบี้ยประกันสุขภาพให้กรมสรรพากร" />
              
            </p>

            <Icon className="ml-auto" src={toggle ? SpanMoreTabTop : SpanMoreTabDown} />
        </div>
    );
}

export default class CheckBoxTax extends Component {
    render() {

        const { onChangeModel, checked } = this.props;

        return(
            <Accordion defaultActiveKey={"0"} className="accordion-wrapper">
                <Card className="accordion-item" key={"0"}>
                <CustomToggle text="รูปแบบรับกรมธรรม์" eventKey={"0"} />
                <Accordion.Collapse eventKey={"0"}>
                    <Card.Body className="pt-1">
                    <div className="d-flex flex-column flex-wrap">
                      <div className={`d-inline radio-button select-horizontal w-100 h-100 ${checked === true ? "active" : ""}`}
                        onClick={() => {onChangeModel({ name: "taxDeduction", value: true })}}
                      >   
                          <div className="radio d-inline ml-0" />
                          <div className="d-inline-block" style={{marginLeft: "30px"}}>
                            ข้าพเจ้ามีความประสงค์ 
                            และยินยอมให้บริษัทเมืองไทยประกันภัย
                            จำกัด(มหาชน) ส่งและเปิดเผยข้อมูลเกี่ยวกับเบี้ยประกันภัย
                            ต่อกรมสรรพกรตามหลักเกณฑ์ วิธีการที่สรรพกรกำหนด
                            จนกว่าจะมีการเปลี่ยนแปลง
                          </div>
                      </div>
                      <div className={`d-inline radio-button select-horizontal position-relative w-100 h-100 mt-2 ${checked === true ? "" : "active"}`}
                        onClick={() => {onChangeModel({ name: "taxDeduction", value: false })}}
                      >   
                        <div className="radio d-inline ml-0" />
                        <div className="d-inline-block" style={{marginLeft: "30px"}}>ไม่มีความประสงค์</div>
                      </div>
                      <div className="radio-button h-0"><div className="radio visibility-hidden"/></div>
                    </div>
                    <div className="mt-3 help-text-wrapper">
                    *เฉพาะผู้ที่ขอใบเสร็จรับเงินในนามผู้เอาประกันภัยเท่านั้น
                    </div>
                    </Card.Body>
                </Accordion.Collapse>
                </Card>
            </Accordion>
        )
    }
}